{
  "authenticate": "Autentificarse"
}
